import { PaymentRequireInfo } from 'app/components/PV04Form/components/types';
import instance from './ApiInstance';

/**
 * 거래등록 api
 * 가맹점 거래 정보를 담은 거래를 최초 등록함
 *
 * @header : merchant-id, sign
 * @param body
 * @returns {Promise<AxiosResponse<any>>}
 */
export const paymentToken = async body => {
  const response = await instance.post(`/payment/token`, body);
  return response;
};

/**
 * Keyin 결제
 * keyin 결제 사용 여부 및 정보요청 api
 *
 * @header : merchant-id, authorization
 * @param body
 * @returns {Promise<AxiosResponse<any>>}
 */
export const keyinPaymentInfo = async body => {
  const response = await instance.post(`/payment/ui/keyin/info`, body);
  return response;
};

/**
 * Billkey등록 정보
 * Billkey등록 사용 여부 및 정보요청 api
 *
 * @header : merchant-id, authorization
 * @param body
 * @returns {Promise<AxiosResponse<any>>}
 */
export const BillkeyRegistrationInfo = async () => {
  const response = await instance.get(`/payment/ui/billkey/info`);
  return response;
};

/**
 * Billkey등록
 * Billkey등록 사용 여부 및 정보요청 api
 *
 * @header : merchant-id, authorization
 * @param body
 * @returns {Promise<AxiosResponse<any>>}
 */
export const BillkeyRegistration = async body => {
  const response = await instance.post(`/payment/ui/billkey`, body);
  return response;
};

/**
 * 결제수단 목록 api
 * 가맹점에 유효한 결제수단 목록 가져오는 api
 *
 * @header : clientKey, mid
 * @param body
 * @returns {Promise<AxiosResponse<any>>}
 */

export const paymentMethodList = async body => {
  const response = await instance.post(`/payment/methodList/${body.mid}`, body);
  return response;
};

/**
 * 사인값 Get api
 * 가맹점에 유효한 Sign Hash값 가져오는 api
 *
 * @header : clientKey, mid
 * @pathParam : orderId, productName, requestCurrency
 * @returns {Promise<AxiosResponse<any>>}
 */

export const signature = async body => {
  const response = await instance.get(
    `/payment/signature?orderId=${body.orderId}&amount=${body.requestAmount}&reqDate=${body.reqDate}`,
  );
  return response;
};

/**
 * 신용카드 비인증(하나카드,KCP) api
 * 가맹점 거래 정보를 담은 거래를 최초 등록함
 *
 * @header : mid, clientkey
 * @param body
 * @returns {Promise<AxiosResponse<any>>}
 */
export const paymentCredit = async body => {
  const response = await instance.post('/payment/ui/credit', body);
  return response;
};

/**
 * 신용카드 인증 api
 * 가맹점 거래 정보를 담은 거래를 최초 등록함
 *
 * @param body
 * @returns {Promise<AxiosResponse<any>>}
 */
export const authCredit = async body => {
  const response = await instance.post('/auth/credit', body);
  return response;
};

/**
 * PV01 (Alipay+,Paypal,Ipay88) 인증 api
 * 가맹점 거래 정보를 담은 거래를 최초 등록함
 *
 * @param body
 * @returns {Promise<AxiosResponse<any>>}
 */
export const authPv01 = async body => {
  const formData = new FormData();
  Object.entries(body).forEach(([key, value]) => {
    formData.append(key, String(value));
  });
  try {
    const response = await instance.post('/auth/PV01', body);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * PV02 (Econtext) 인증 api
 * 가맹점 거래 정보를 담은 거래를 최초 등록함
 *
 * @param body
 * @returns {Promise<AxiosResponse<any>>}
 */
export const authPv02 = async body => {
  const response = await instance.post('/auth/PV02', body);
  return response;
};

/**
 * PV03 (Wechat) 인증 api
 * 가맹점 거래 정보를 담은 거래를 최초 등록함
 *
 * @param body
 * @returns {Promise<AxiosResponse<any>>}
 */
export const authPv03 = async body => {
  const response = await instance.post('/auth/PV03', body);
  return response;
};

/**
 * PVKR (국내 신용카드) 인증 api
 * 가맹점 거래 정보를 담은 거래를 최초 등록함
 *
 * @param body
 * @returns {Promise<AxiosResponse<any>>}
 */
export const authPvkr = async body => {
  const response = await instance.post('/auth/PVKR', body);
  return response;
};

/**
 * 거래 결과 확인
 * 거래 최종 결과 확인
 *
 * @header : tid
 * @returns {Promise<AxiosResponse<any>>}
 */
export const innerSearch = async tid => {
  return await instance.get(`/payment/innerSearch/${tid}`);
};

/**
 * 결제에 필수적인 정보를 받아오는 api
 * 결과값을 바탕을 동적인 폼 생성
 */
export const getPaymentRequireInfo = async (
  schemeCode,
): Promise<PaymentRequireInfo> => {
  const res = await instance.get(`/payment/ui/require/info/${schemeCode}`);

  return res.data;
};

export const shopifySearch = async body => {
  return await instance.post(`/payment/shopify/completing`, body);
};

export const appleValidate = async body => {
  return await instance.post(`/payment/applepay/validate`, body);
};

export const appleApprove = async body => {
  return await instance.post(`/payment/applepay/approve`, body);
};

export const googlePayApprove = async body => {
  return await instance.post(`/payment/googlepay/approve`, body);
};
